import { useEffect, useRef, useState } from "react";
import { PHOREST_BOOKING_URL } from "@/data/content";

const FALLBACK_MS = 8000;

const PhorestBooking = ({ status, onStatus, src = PHOREST_BOOKING_URL, lazy = false, height = 760, onLoaded, onInteract }) => {
  const [armed, setArmed] = useState(!lazy);
  const frame = useRef(null);

  useEffect(() => {
    if (!lazy) return;
    const t = setTimeout(() => setArmed(true), 400);
    return () => clearTimeout(t);
  }, [lazy]);

  useEffect(() => {
    if (!armed || status !== "loading") return;
    const timer = setTimeout(() => onStatus("failed"), FALLBACK_MS);
    return () => clearTimeout(timer);
  }, [armed, status, onStatus]);

  useEffect(() => {
    if (!onInteract) return;
    const onBlur = () => {
      if (document.activeElement === frame.current) onInteract();
    };
    window.addEventListener("blur", onBlur);
    return () => window.removeEventListener("blur", onBlur);
  }, [onInteract]);

  return (
    <div className={status === "failed" ? "hidden" : "relative"} style={{ height }} data-testid="online-booking">
      {status === "loading" && (
        <p className="absolute inset-0 flex items-center justify-center text-soft-grey text-sm bg-cream" data-testid="online-booking-loading">
          Loading live availability…
        </p>
      )}
      {armed && (
        <iframe
          ref={frame}
          src={src}
          name="onlinebooking"
          title="Book online — Lumière Aesthetics"
          allow="payment"
          className="w-full h-full border-0 bg-cream"
          onLoad={() => {
            onStatus("ready");
            onLoaded?.();
          }}
          data-testid="online-booking-iframe"
        />
      )}
    </div>
  );
};

export const OpenBookingLink = ({ href = PHOREST_BOOKING_URL, className = "" }) => (
  <p className={`text-soft-grey text-xs ${className}`} data-testid="online-booking-open-link">
    Booking not loading?{" "}
    <a href={href} target="_blank" rel="noopener noreferrer" className="link-sea">
      Open the booking page in a new tab
    </a>
  </p>
);

export default PhorestBooking;
